import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const CategoryApiResources = {
  list:  createUrl('categories'),
  create:  createUrl('categories/create'),
  detail:  createUrl('categories'),
  update:  createUrl('categories'),
  delete:  createUrl('categories'),
};
